import { useSelector } from "react-redux";
import { URLS } from "../API/API endpoints";
import axiosInstance from "../AxiosInstance";
import i18next from "i18next";
import { toast } from "react-toastify";
import { t } from "i18next"


export const getExpenseTypes = async (company_id) => {
  try {
    let lang = i18next.language;

    if (lang === "ar") {
      lang = "ar_001"; 
    } else if (lang === "en") {
      lang = "en_US";  
    }

    const payload = { company_id, lang }; 
    const response = await axiosInstance.post(URLS.GET_EXPENSE_TYPES, payload);

    return response.data; 
  } catch (error) {
    return error;
  }
};

export const getExpensePaymentMethods = async (company_id) => {
  try {
    const payload = { company_id }; 
    const response = await axiosInstance.post(URLS.GET_EXPENSE_METHODS, payload);

    return response.data; 
  } catch (error) {
    return error;
  }
};

export const fetchMethodBalance = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_EXPENSE_METHODS_BALANCE, payload);

    return response.data; 
  } catch (error) {
    return error;
  }
};

// Create a new expense type
export const createExpenseType = async (companyId, expenseType) => {

   const payload = {
      company_id : companyId,
      name: expenseType
    };
  try {
    const response = await axiosInstance.post(URLS.CREATE_EXPENSE_TYPE, payload);
    return response.data; // return created type
  } catch (error) {
    return error;
  }
};

// Create a new expense entry
export const createExpenseEntry = async ({
  company_id,
  user_id,
  amount,
  remark,
  expense_type,
  expense_date,
  payment_method,
}) => {
  try {
    const payload = {
      company_id,
      user_id,
      amount,
      remark,
      expense_type,
      expense_date,
      payment_method,
    };
    const response = await axiosInstance.post(URLS.CREATE_EXPENSE, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

// Get expense transactions
export const getExpenseTransactions = async ({
  user_id,
  company_id,
  start_date,
  end_date,
  limit = 10,
  offset = 0,
  is_expense,
  expense_type
}) => {
  try {
    const payload = {
      user_id,
      company_id,
      start_date,
      end_date,
      limit,
      offset,
      is_expense,
      expense_type
    };
    const response = await axiosInstance.post(URLS.GET_EXPENSE_TRANSACTIONS, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};


export const editOrDeleteExpenseEntry = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.EDIT_DELETE_EXPENSE, payload);
    return response.data;
  } catch (error) {
    console.error("Error editing/deleting expense:", error);
    throw error;
  }
};

export const getAccountingOverview = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_ACCOUNTING_OVERVIEW, payload);
    return response.data?.result || {};
  } catch (error) {
    console.error("Error in GetAccountingOverview", error);
    throw error;
  }
};

// Get Profit & Loss
export const getAccountingProfitLoss = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_ACCOUNTING_PROFIT_LOSS, payload);
    return response.data?.result || {};
  } catch (error) {
    console.error("Error in GetAccountingProfitLoss", error);
    throw error;
  }
};